export default __webpack_public_path__ + "static/media/T680_RoHS.ad58d16a.pdf";